export function getApplicationId(appName, menus) {
   let application = null
   const appTitle = appName.replaceAll('-', ' ').toLowerCase().trim()
   if (menus && menus.length) {
      outerLoop: for (let i = 0; i < menus.length; i++) {
         const { menus: submenus } = menus[i]
         for (let j = 0; j < submenus.length; j++) {
            const { title: menuAppTitle } = submenus[j]
            if (appTitle === menuAppTitle.toLowerCase().trim()) {
               application = submenus[j]
               break outerLoop
            }
         }
      }
   }
   return application.id.replace('menu-', '')
}

export function getApplicationBaseUrl(applicationId, resources) {
   return resources[applicationId].link
}

export function createScriptElement(elemetId, srcUrl, dispatch) {
   const script = document.getElementById(elemetId)
   if (script) {
      script.remove()
   }
   const newScript = document.createElement('script')
   newScript.id = elemetId
   newScript.async = false
   newScript.src = srcUrl
   newScript.onload = function () {
      dispatch({ type: 'CLOSE_SPINNER' })
   }
   return newScript
}

export function createLinkElement(elementId, srcUrl) {
   const style = document.getElementById(elementId)
   if (style) {
      style.remove()
   }
   const newStyle = document.createElement('link')
   newStyle.id = elementId
   newStyle.type = 'text/css'
   newStyle.rel = 'stylesheet'
   newStyle.href = srcUrl
   return newStyle
}
